import { render } from "./LandPage.vue?vue&type=template&id=4b023e95&scoped=true&ts=true"
import script from "./LandPage.vue?vue&type=script&lang=ts"
export * from "./LandPage.vue?vue&type=script&lang=ts"

import "./LandPage.vue?vue&type=style&index=0&id=4b023e95&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b023e95"]])

export default __exports__